
// import AccettazionePrenotazioniLazioListPage from "./pages/AccettazionePrenotazioniLazioListPage.vue";
import AccettazioneSsnEditViewPage from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneFrosinoneListPage from "./pages/AccettazioneSsnListaPage.vue";
import AccettazionePrenotazioniLazioListPage from "./pages/AccettazionePrenotazioniLazioListPage.vue"
import AccettazioneRicettaPrestazioniListaPage from "../ricettaprestazioniappuntamenti/pages/AccettazioneRicettaPrestazioniListaPage.vue";



export default {
    AccettazioneSsnEditViewPage,
    AccettazioneFrosinoneListPage,
    AccettazionePrenotazioniLazioListPage,
    AccettazioneRicettaPrestazioniListaPage
};
